export default {
  nav: {
    home: "首页",
    product: "产品介绍",
    product2: "主页",
    tutorial: "下载&教程",
    advantage: "行业优势",
    userInstance: "用户实例",
    productScheme: "产品方案",
    pay: "充值中心",
    account: "账户中心",
    login: "登录",
    register: "免费注册",
    logout: "退出",
    wechat: "微信",
    wsService: "WS客服",
    privateMessage: "私信",
    about: "关于我们",
  },
  common: {
    welcome: "欢迎",
    home: "首页",
    back: "返回",
    next: "下一步",
    previous: "上一步",
    confirm: "确认",
    cancel: "取消",
    save: "保存",
    edit: "编辑",
    delete: "删除",
    search: "搜索",
    loading: "加载中...",
    noData: "暂无数据",
    success: "操作成功",
    error: "操作失败",
    // 退出登录对话框
    logoutTitle: "退出登录",
    logoutMessage: "确定要退出登录吗？",
    confirmText: "确定",
    cancelText: "取消",
    // 登录状态过期
    loginExpired: "登录状态已过期，请重新登录",
    reLogin: "重新登录",
    // 安全验证（Cloudflare 挑战）
    securityCheckExpired: "安全验证已过期，请刷新页面重新验证",
    refreshPage: "刷新页面",
  },
  logout: {
    processing: "正在退出...",
    success: "退出成功",
    failed: "退出失败",
  },
  homeHero: {
    titlePrefix: "TranGPT - ",
    titleHighlight: "帮你做最强业绩",
    descLine1: "支持 180+语言互译、文档翻译、实时语音合成、RESTful API 集成",
    descLine2Prefix: "为跨境电商、外贸、出海企业提供一站式",
    descLine2Highlight: "多语言解决方案",
    descLine2Suffix: "",
    cta: "免费开始使用",
  },
  contactBanner: {
    officialContact: "官方联系方式",
    officialEmail: "官方邮箱",
  },
  // Product页面
  product: {
    title: "TranGPT不能代替客户开发\n但拥有TranGPT将更快的开发客户\n销冠必备AI客服系统",
    description: "支持120个国家和地区的语言翻译，让您的咨询无国界!",
    tryNow: "立即试用",
    downloadNow: "立即下载",
    consultDiscount: "咨询领取优惠",
    multiApp: "多个应用，一个客户端搞定",
    userManagement: "用户管理一键搞定",
    multiAccount: "多账号同时在线，轻松搞定",
    clientMultiOpen: "客户端多开",
    support120Languages: "支持120+语言精准翻译",
    realTimeTranslation: "支持实时翻译，0失误",
    bidirectionalTranslation: "双向翻译，不出错",
    aiOptimization: "AI优化、真人语音克隆",
    userTrust: "用户放心",
    stableReliable: "稳定可靠",
    grabOpportunity: "抓住每一个销售机会",
    whyUsingTranGPT: "为什么都在用TranGPT",
    whatsappSolution: "whatsApp 出海解决方案",
    whatsappDesc: "直接通过我们统一的后台，提供出色的客户服务并释放销售机会。",
    facebookTool: "Facebook 智能服务工具",
    facebookDesc:
      "提供出色的客户服务并释放销售机会统一管理所有社交媒体消息，利用Facebook集成批量链接多个主页节省时间和人力",
    communicationPlatform: "适用于所有卖家的沟通平台",
    windowsDownload: "Windows下载",
    win64: "（win64位）",
    win7Version: "(win7版本)",
    contactAdvisor: "立即联系您的专属顾问",
    telegramConsult: "Telegram咨询客服 免费试用",
    productManager: "产品经理",
    userReview:
      "凭借其强大的精细调整模型，让AI艺术变得轻而易举。让我发现最好的社区!",
    // Product2页面新增字段
    supportGlobal: "支持全球20+软件实时翻译及AI辅助",
    oneEndMultiOpen: "一端多开，不需要额外软件",
    voiceClone: "真人语音克降，语音不担心",
    speechOptimization: "话术优化，支持不同文化场景AI优化",
    aiModelIntegration: "接入各大AI大模型，放心用",
    ourPromise: "我们的承诺",
    securityEncryption: "安全加密",
    globalTopEncryption: "· 全球顶尖加密技术",
    serverMultiEncryption: "· 服务器多层加密",
    privacyDataSecurity: "· 保证隐私和数据安全",
    industryLeadingProtocol: "· 行业领先加密传输协议",
    languageExpertGuarantee: "· 语言专家对语言翻译的保证",
    translate100kWords: "· 翻译10万字无中断、无错误",
    serve100kUsers: "· 服务全球10万+用户",
    uniqueVoiceClone: "· 克隆音色唯一，用户放心",
    techEnterpriseSupport: "· 背靠技术企业稳定可靠",
    globalTopAI: "· 接入全球顶尖AI模型",
    customizableFeatures: "· 功能可定制化需求",
    onlineNoLag: "· 同时在线不卡顿",
    macDownload: "Mac下载",
    appleChip: "（Apple 芯片 M系列，2020年后机型）",
    intelChip: "（Intel 芯片，2020年前机型）",
    appleChipHint: "5年内苹果机（普遍）",
    intelChipHint: "5年以上苹果机（少见）",
    recommended: "推荐",
    communicationPlatformDesc:
      "利用语音克隆，AI辅助，全面提升销售业绩和客户满意度。",
    productManagerRole: "产品经理",
    userReview2:
      "凭借其强大的精细调整模型，让AI艺术变得轻而易举。让我发现最好的社区!",
    // Product2页面用户评价部分
    globalSoftwareSupport: "支持全球20+软件实时翻译及AI辅助",
    productManagerTitle: "产品经理",
    userTestimonial:
      "凭借其强大的精细调整模型，让AI艺术变得轻而易举。让我发现最好的社区!",
  },
  // Login页面
  login: {
    title: "会员登录",
    email: "邮箱",
    password: "密码",
    rememberPassword: "记住密码",
    forgotPassword: "忘记密码",
    loginBtn: "登录",
    agreeTerms: "注册即表示您同意",
    serviceAgreement: "服务协议",
    privacyPolicy: "隐私政策",
    noAccount: "还没有账号？",
    goRegister: "立即注册",
    // 新增消息提示
    logging: "登录中...",
    pleaseEnterEmailAndPassword: "请输入邮箱和密码",
    loginFailed: "登录失败",
    loginError: "登录错误，请稍后重试",
    loginSuccess: "登录成功！正在跳转到账户中心...",
  },
  // Reset Password页面
  resetPassword: {
    title: "重置密码",
    step1Title: "输入邮箱地址",
    step2Title: "设置新密码",
    emailLabel: "邮箱地址",
    emailPlaceholder: "请输入您的邮箱地址",
    sendResetLink: "发送重置链接",
    sending: "发送中...",
    newPasswordLabel: "新密码",
    newPasswordPlaceholder: "请输入新密码",
    confirmPasswordLabel: "确认密码",
    confirmPasswordPlaceholder: "请确认新密码",
    resetPassword: "重置密码",
    resetting: "重置中...",
    backToLogin: "返回登录",
    linkSent: "重置链接已发送到您的邮箱，请点击邮件中的链接完成密码重置。",
    linkSentSuccess:
      "重置密码链接已发送到您的邮箱，请在30分钟内完成密码重置。如果没有收到邮件，请检查垃圾邮件文件夹。",
    checkSpamFolder:
      "如果没有收到邮件，请检查垃圾邮件文件夹。如果仍未收到邮件，请尝试重新发送或联系客服支持。",
    captchaError: "验证码验证失败，请重试",
    captchaExpired: "验证码已过期，请重新验证",
    resendCountdown: "重新发送({seconds}秒)",
    resetSuccess: "密码重置成功，即将跳转到登录页面",
    sendLinkError: "发送重置链接失败，请重试",
    resetError: "密码重置失败，请重试",
    passwordTooShort: "密码长度不能少于8个字符",
    passwordTooLong: "密码长度不能超过32个字符",
    passwordNeedLowercase: "密码必须包含小写字母",
    passwordNeedUppercase: "密码必须包含大写字母",
    passwordNeedNumber: "密码必须包含数字",
    passwordMismatch: "两次输入的密码不一致",
    invalidToken: "重置链接无效或已过期，请重新申请",
    tokenRequired: "缺少重置令牌，请通过邮件链接访问此页面",
    pleaseEnterEmail: "请输入邮箱地址",
    invalidEmail: "请输入有效的邮箱地址",
    passwordValidationError: "密码格式不符合要求",
  },
  // Register页面
  register: {
    title: "注册账号",
    username: "输入用户名称",
    password: "输入用户密码",
    email: "邮箱",
    verificationCode: "验证码",
    getCode: "获取验证码",
    invitationCode: "邀请码(选填)",
    teamSizePlaceholder: "请选择团队规模(选填)",
    contactTypePlaceholder: "请选择联系方式",
    contactPlaceholder: "请输入联系方式(选填)",
    registerBtn: "注册",
    agreeTerms: "注册即同意",
    serviceAgreement: "服务协议",
    privacyPolicy: "隐私政策",
    hasAccount: "已有账号？",
    goLogin: "去登录",
    // 新增的提示信息
    emailRequired: "请输入邮箱地址",
    codeSending: "发送中...",
    codeSent: "验证码已发送到您的邮箱",
    codeSendFailed: "发送验证码失败",
    allFieldsRequired: "请填写所有必填字段",
    registering: "注册中...",
    registerSuccess: "注册成功！正在跳转到登录页面...",
    registerFailed: "注册失败",
    captchaError: "验证码验证失败，请重试",
    captchaExpired: "验证码已过期，请重新验证",
    teamSizeOptions: {
      "1to10": "1-10",
      "10to20": "10-20",
      "20to50": "20-50",
      "50to100": "50-100",
      "100plus": "100以上",
    },
    contactTypes: {
      telegram: "Telegram",
      whatsapp: "WhatsApp",
      wechat: "微信",
    },
  },
  // Footer组件
  footer: {
    slogan: "努力推动科技与语言的融合",
    description: "不断突破技术边界，创新的解决方案满足不断变化的市场需求",
    functionIntro: "功能介绍",
    tutorial: "下载&教程",
    purchaseRecord: "购买记录",
    wechatService: "微信扫码添加客服",
    copyright: "TranGPT © COPYRIGHT 2018-2023 ALL RIGHTS RESERVED.",
    companyInfo: "版权所有 © Mohist AI Systems Limited 联系邮箱：contact@trangpt.ai",
  },
  // Pay页面
  pay: {
    title: "充值中心",
    packageRecharge: "套餐充值",
    supportPayment: "支持USDT-TRC20网络 & Stripe信用卡支付",
    packageQuantity: "宇符包及购买数量",
    orderAmount: "订单金额",
    payableAmount: "应付金额：",
    paymentMethod: "支付方式",
    usdtPayment: "USDT-TRC20 (仅支持USDT-TRC20网络)",
    stripePayment: "Stripe支付 (支持信用卡/借记卡)",
    copyAddress: "复制地址",
    addressCopied: "地址已复制到剪贴板",
    nextStep: "下一步",
    notice: "注意：支付金额必须完全相同，否则订单无效",
    usdtOption: "USDT-TRC20 (仅支持USDT-TRC20网络)",
    stripeOption: "Stripe支付 (支持信用卡/借记卡)",
    contactAdvisor: "立即联系您的专属顾问",
    telegramConsult: "Telegram咨询客服 免费试用",
    // 倒计时相关
    paymentCountdown: "支付倒计时",
    remainingTime: "剩余时间",
    paymentInstructions: "请在规定时间内完成支付，超时订单将自动失效",
    paymentExpired: "支付时间已过期",
    paymentExpiredMessage: "支付时间已过期，请重新发起支付",
  },
  // Tutorial页面
  tutorial: {
    description:
      "快来开始您的体验吧若需要更进一步资讯，请不要犹豫与我们联系，很高兴能为您服务！",
    startNewExperience: "从下载开始新的体验",
    registerExclusiveAccount: "注册属于你的专属账号",
    loginStartJourney: "登录开启新的旅程",
    setToChinese: "简单设置成中文",
    startBarrierFreeCommunication: "点击开始无障碍交流",
    clearerVideoGuide: "更清晰的视频指引",
    step1Title: "点击官网任意按钮下载TRANGPTT并安装。",
    step1Desc: "下载并安装TranGPT应用程序",
    macDownload: "Mac下载",
    appleChip: "（Apple 芯片 M系列，2020年后机型）",
    intelChip: "（Intel 芯片，2020年前机型）",
    appleChipHint: "5年内苹果机（普遍）",
    intelChipHint: "5年以上苹果机（少见）",
    recommended: "推荐",
    windowsDownload: "Windows下载",
    win64: "（win64位）",
    win7Version: "(win7版本)",
    step2Title:
      "输入你的个人信息开始注册邮箱必须为真实邮箱 我们怕联系不上你的哦。",
    step2Desc: "注册并登录您的账户",
    step3Title:
      "登录账号，在您使用聊天的同时就能时时翻译了。开启你与世界的连结之旅吧~",
    step3Desc: "选择您需要的翻译语言",
    step4Title:
      "登录账号，在您使用聊天的同时就能时时翻译了。开启你与世界的连结之旅吧~",
    step4Desc:
      "登录账号，在您使用聊天的同时就能时时翻译了。开启你与世界的连结之旅吧~",
    step5Title:
      "快来开始您的体验吧若需要更进一步资讯，请不要犹豫与我们联系，很高兴能为您服务！",
    step5Desc: "开始享受实时翻译服务",
    step6Title:
      "快来开始您的体验吧若需要更进一步资讯，请不要犹豫与我们联系，很高兴能为您服务！",
    step6Desc:
      "快来开始您的体验吧若需要更进一步资讯，请不要犹豫与我们联系，很高兴能为您服务！",
    contactAdvisor: "立即联系您的专属顾问",
    contactConsultant: "立即联系您的专属顾问",
    telegramConsult: "Telegram咨询客服 免费试用",
  },
  // ProductScheme页面
  productScheme: {
    quarterlyPackage: "季度套餐",
    quarterlyPlan: "季度套餐",
    deepLChatGPT: "DEEPL+CHATGPT",
    deeplChatgpt: "DEEPL+CHATGPT",
    buyNow: "立即购买",
    unlimitedChars: "不限字符使用，不限登陆端口",
    unlimitedTime: "不限制使用时间，不限登陆端口",
    ipConfig: "支持账户IP配置",
    fingerprint: "帐号指纹环境隔离",
    aiReply: "AI自动回复，AI侧窗问答",
    millionChars: "1000W 字符",
    chars200w: "375W 字符",
    chars1000w: "1880W 字符",
    chars15000w: "15000W 字符",
    flagshipPlan: "旗舰套餐",
    monthlyPlan: "包月套餐",
    singleUserOnly: "单人专属版，不可开通子账号",
    portCustomTitle: "定制",
    portCustomUnit: "端口套餐",
    portPriceFrom: "40U 起",
    contactForDetails: "详情联系客服咨询",
    portFeature1: "支持端口定制功能，支持工单计数及业务聊天进度查阅",
    portFeature2: "单次定制 100 个端口及以上，8U/端口起，享最高优惠",
    contactAdvisor: "立即联系您的专属顾问",
    telegramConsult: "Telegram咨询客服 免费试用",
    bannerFeatureTranslate: "180+语言文本互译",
    bannerFeatureTerminology: "自定义术语库",
    bannerFeatureTts: "高自然度文本转语音(TTS)",
    bannerFeatureVoiceTranslate: "实时语音翻译",
    bannerFeatureTeam: "团队协作功能",
    bannerFeatureDocument: "多格式文档翻译",
    bannerTitle: "价格方案",
    bannerDesc1:
      "在全球化的时代，和欧美客户的沟通如此重要。但文化与语言的差异，常常是最大的挑战。",
    bannerDesc2:
      "现在，我们引入了新一代出海客服系统 - TranGPT，为您提供最真实、最自然的沟通体验！",
  },
  // Advantage页面
  advantage: {
    threeAdvantages: "与众不同的3大优势",
    bannerTitle: "行业优势",
    bannerDesc: "人工智能 AI 高效简洁的翻译功能，聚合全球主流社交应用，实现双向翻译",
    cooperateWith200Companies: "跟超200+家企业达成合作让出海沟通更轻松",
    chooseTranGPTSimple: "选择TRANGPT 很简单",
    title1: "采用TRANGPT4 实现毫秒级别的高效翻译，满足客户的感官上的需求",
    realTime: "实时/REAL TIME",
    realTimeDesc1: "个性化翻译",
    realTimeDesc2: "进行语气上的修饰优化",
    realTimeDesc3: "AI根据和客户的聊天内容生成回复",
    efficient: "高效/HIGHLY EFFICIENT",
    efficientDesc1: "自定义场景和聊天语气",
    efficientDesc2: "结合上下文自动生成回复",
    efficientDesc3: "秒回客户各种专业问题",
    accurate: "精准/ACCURATE",
    accurateDesc1: "TRANGPT自然语言翻译",
    accurateDesc2: "AI智能客服系统",
    accurateDesc3: "贴近表达者习惯的沟通体验",
    title2: "采用TRANGPT4 实现毫秒级别的高效翻译，满足客户的感官上的需求",
    convenient: "便捷易用",
    convenientDesc1: "操作简单",
    convenientDesc2: "易上手从下载开始",
    multiLanguage: "多语言支持",
    multiLanguageDesc1: "优秀的开发团队",
    multiLanguageDesc2: "极致细节的设计",
    globalCoverage: "全球覆盖",
    globalCoverageDesc1: "操作简单",
    globalCoverageDesc2: "易上手从下载开始",
    professionalTranslation: "专业翻译",
    professionalTranslationDesc1: "多重加密",
    professionalTranslationDesc2: "独立部署，数据完整隔离",
    intelligentRecognition: "智能识别",
    aiIntelligence: "AI智能",
    deepLearning: "深度学习",
    continuousOptimization: "持续优化",
    revolutionaryTitle: "颠覆传统的翻译体验",
    revolutionaryDesc:
      "TranGPT是一个基于人工智能技术的社交应用程序，它可以高效地简洁地实现翻译功能。通过使用机器学习技术，TranGPT可以自动学习语言和文化，从而实现准确的翻译。TranGPT还可以利用自然语言处理技术来识别和理解用户的语言和文化背景，从而提供更加精准的翻译结果。",
    socialManagementTitle: "一站式海外社交管理",
    socialManagementDesc:
      "TranGPT聚合了全球主流的社交应用，包括 Facebook、 Twitter、Instagram等，同时也实现了双向翻译功能。用户可以通过输入文本或图片等形式与其他用户进行交流。TranGPT还提供了各种社交应用的接口，可以方便地与其他用户进行交流和互动。它还具有自动纠错和自动标点功能，帮助用户更好地理解和使用语言。",
    aiAssistantTitle: "超智能AI助手",
    aiAssistantDesc:
      "TranGPT还提供了智能助手的功能，可以帮助用户完成各种任务和操作。同时，智能助手也可以帮助提供信息、回答问题、执行任务等操作。它采用了深度学习算法和自然语言处理技术，能够快速准确地识别和翻译不同语言的文本和图像。 TranGPT人工智能AI高效简洁的翻译功能支持多种文本类型，包括新闻、邮件、社交媒体等等。它可以自动识别文本中的重要信息，并将其翻译成相应的语言。",
    personalizationTitle: "深度个性化服务",
    personalizationDesc:
      "Translation Attention Profiling （TAP）：TranGPT可以通过学习大量的文本，来分析和预测不同的语言之间的关系，例如语法、语义、情感等方面，从而实现更加个性化和准确的翻译。12各大高校正在研发与 TranGPT相类似功能或技术产品 13 TranGPT人工智能AI高效简洁的翻译功能是一种全新技术，它具有非常大前景，可以应用于很多领域，包括机器翻译等。 14 TranGPT深度个性化服务是一种深度定制服务，它可以根据不同用户需求来进行定制和优化，以满足不同用户需求。",
    contactAdvisor: "立即联系您的专属顾问",
    telegramConsult: "Telegram咨询客服 免费试用",
  },
  // Account页面
  account: {
    title: "账户中心",
    accountHome: "账户首页",
    orderManagement: "订单管理",
    changePassword: "修改密码",
    changeEmail: "更换邮箱",
    changeUsername: "修改用户名",
    packageList: "套餐列表",
    orderList: "订单管理",
    number: "编号",
    type: "类型",
    quantity: "数量",
    port: "端口",
    status: "状态",
    validTime: "有效时间",
    oldPassword: "旧密码",
    newPassword: "新密码",
    confirmPassword: "确认密码",
    oldPasswordPlaceholder: "请输入旧密码",
    newPasswordPlaceholder: "请输入新密码",
    confirmPasswordPlaceholder: "请确认新密码",
    changePasswordBtn: "更改密码",
    currentPassword: "当前密码",
    newEmail: "新邮箱",
    currentPasswordPlaceholder: "请输入当前密码",
    newEmailPlaceholder: "请输入新邮箱",
    changeEmailBtn: "更换邮箱",
    contactAdvisor: "立即联系您的专属顾问",
    telegramConsult: "Telegram咨询客服 免费试用",
    packageTypes: {
      character: "字符套餐",
      monthly: "包月套餐",
      daily: "按天套餐",
      port: "端口套餐",
      other: "其他套餐",
    },
    packageStatus: {
      unused: "未使用",
      using: "正在使用",
      expired: "已过期",
      unknown: "未知",
    },
    changing: "修改中...",
    verificationCode: "验证码",
    verificationPlaceholder: "请输入验证码",
    getVerificationCode: "获取验证码",
    sendCodeSuccess: "验证码已发送到您的新邮箱",
    sendCodeFailed: "发送验证码失败",
    sendCodeFailedRetry: "发送验证码失败，请稍后重试",
    fetchOrderDetailFailed: "获取订单详情失败，请稍后重试",
    fetchUserInfoFailed: "获取用户信息失败，请稍后重试",
    passwordRequired: "请输入密码",
    passwordLength: "密码长度必须在8-32个字符之间",
    passwordComplexity: "密码必须包含大小写字母和数字",
    oldPasswordRequired: "请输入旧密码",
    confirmPasswordRequired: "请确认新密码",
    passwordsNotMatch: "两次输入的密码不一致",
    passwordChangeSuccess: "密码修改成功，进入重新登录界面。",
    passwordChangeFailed: "修改密码失败，请稍后重试",
    newEmailRequired: "请输入新邮箱地址",
    newEmailInvalid: "请输入有效的邮箱地址",
    verificationCodeRequired: "请输入验证码",
    emailChangeSuccess: "邮箱修改成功！",
    emailChangeFailed: "邮箱修改失败",
    emailChangeFailedRetry: "更换邮箱失败，请稍后重试",
    newUsername: "新用户名",
    newUsernamePlaceholder: "请输入新用户名",
    changeUsernameBtn: "保存修改",
    usernameRequired: "请输入用户名",
    usernameTooLong: "用户名长度不能超过80个字符",
    usernameChangeSuccess: "用户名修改成功！",
    usernameChangeFailed: "用户名修改失败",
    usernameChangeFailedRetry: "修改用户名失败，请稍后重试",

    // 订单状态
    orderStatus: {
      pending: "待付款",
      reviewing: "待审核",
      approved: "通过",
      rejected: "驳回",
      expired: "已失效",
      refunded: "已退款",
      unknown: "未知状态",
    },

    // 订单管理界面
    orderFilter: {
      all: "全部订单",
      pending: "待支付",
    },

    orderTable: {
      orderNo: "订单号",
      date: "日期",
      type: "类型",
      quantity: "数量",
      amount: "订单金额",
      status: "订单状态",
      operation: "操作",
      detail: "详情",
      loading: "加载中...",
      noData: "暂无订单数据",
    },

    pagination: {
      previous: "上一页",
      next: "下一页",
      pageInfo: "第 {current} 页，共 {total} 页",
    },
    orderDetail: {
      title: "订单详情",
      orderNo: "订单编号",
      name: "套餐名称",
      quantity: "数量",
      price: "价格",
      payment: "付款",
      orderTime: "下单时间",
      status: "状态",
    },
  },
  // Product页面（原版）
  productOriginal: {
    alwaysByYourSide: "无论您需要什么，TranGPT 始终在您身边",
    efficientConvenientFast: "高效方便快捷",
    support180Countries: "支持180+国家和地区语言翻译交流无国界",
    newArchitecture: "全新架构，极致稳定",
    encryptionSecurity: "加密守护，极致安全",
    independentIP: "会话独立IP设置",
    multiLanguage: "多语言实时双向翻译",
    aiTitle: "人工智能",
    languageSupport: "广泛的语言支持",
    languageSupportDesc:
      "TRANGPT支持多种语言翻译，包括但不限于英语、中文、日语、法语、德语、西班牙语等，覆盖了全球大多数使用的语言。",
    fastTranslation: "快速准确翻译",
    fastTranslationDesc:
      "TRANGPT通过深度学习技术，能够快速准确地翻译各种文本，包括新闻报道、商业文件、电子邮件、旅游资料等。",
    autoMemory: "自动记忆更新",
    autoMemoryDesc:
      "TRANGPT具有自动记忆更新的功能，能够根据用户的使用习惯，自动优化翻译结果，提高翻译的准确性和流畅度。",
    multiFormat: "多种输出格式",
    multiFormatDesc:
      "TRANGPT支持多种输出格式，如文本、PDF、图片等，方便用户根据需要选择。",
    socialManagementTitle: "一站式海外社交管理",
    fastSpeed: "速度快",
    fastSpeedDesc:
      "TRANGPT具有很高的效率，可以在短时间内完成多种语言的翻译。这使得翻译工作变得更加快捷和高效。",
    highQuality: "质量高",
    highQualityDesc:
      "使用了先进的人工智能技术，能够识别出语言中的语法、词汇和语气等方面的问题，从而提高翻译的质量。",
    easyToUse: "易于使用",
    easyToUseDesc:
      "翻译功能简单易用，使用者可以轻松地设置参数和调整翻译质量。这使得用户体验更加友好。",
    scalable: "可扩展性强",
    scalableDesc:
      "TRANGPT它的快速简洁、高质量、易使用和可扩展性强等特点，为用户提供了一种更加便捷、高效和友好的翻译体验。",
    socialManagement: "社交管理",
    socialManagementDesc:
      "RANGPT人工智能 AI高效简洁的翻译功能还可以帮助用户在社交平台上管理自己的账号、消息、粉丝等信息。",
    personalizationTitle: "深度个性化服务",
    translationFunction: "翻译功能",
    translationFunctionDesc:
      "工智能 AI具有强大的翻译功能，可以帮助用户快速准确地翻译多种语言。",
    grammarCheck: "语法检查",
    grammarCheckDesc:
      "人工智能 AI支持语法检查功能，可以帮助用户检查和纠正英语语法错误。它可以检测出句子中的语法错误并提供相应的修改建议。",
    termManagement: "术语管理",
    terminologyManagementDesc:
      "人工智能 AI还具有术语管理功能，可以帮助用户将翻译结果中的术语提取出来，以便用户能够更好地理解和使用它们。",
    multiLanguageSupport: "多语言支持",
    multiLanguageSupportDesc:
      "人工智能 AI还支持多语言支持，可以自动识别并翻译多种语言的句子和单词。",
    bilingualDictionary: "双语词库",
    bilingualDictionaryDesc:
      "人工智能 AI还支持双语词库功能，可以将两种不同语言的单词和短语自动合并为一种语言。",
    trangpt4Description:
      "采用TRANGPT4 实现毫秒级别的高效翻译，满足客户的感官上的需求。",
    commonProblems:
      "生活中常见的问题 对事物运行规律缺乏系统认知，容易导致常规事务处理混乱。当环境干扰因素复杂化时，情绪掌控失效会削弱问题处置的能力？",
    aiResponse:
      "Common problems in life: Lack of systematic understanding of the laws governing things can easily lead to confusion in handling routine",
    systemSupport:
      "系统支持多语种界面与实时翻译，即时转换客对话，让您不用担心语言隔阂。",
    coreAdvantagesTitle: "核心优势",
    coreAdvantageGptTitle: "GPT 架构翻译更准确",
    coreAdvantageGptDesc: "基于 GPT 架构深度微调，上下文理解强，长句、专业术语更精准。",
    coreAdvantageLanguageTitle: "180+ 全语种覆盖",
    coreAdvantageLanguageDesc: "覆盖全球主流语言 + 小语种，远超同类工具。",
    coreAdvantageTtsTitle: "翻译 + TTS 一体化",
    coreAdvantageTtsDesc: "翻译结果一键转真人感语音，客服 / 直播 / 教育场景可用。",
    coreAdvantageSecurityTitle: "国内稳定访问 + 合规安全",
    coreAdvantageSecurityDesc: "无需翻墙，企业级隐私保护，数据不出境。",
    suitableForTitle: "适合谁用",
    audienceCrossBorderSeller: "跨境电商卖家",
    audienceTradeSales: "外贸业务员",
    audienceBrandOperation: "出海品牌运营",
    audienceDeveloperIntegration: "开发者/技术集成",
    audienceSupportTeam: "多语言客服团队",
    audienceConferenceLive: "国际会议/直播",
    contactAdvisor: "立即联系您的专属顾问",
    contactConsultant: "立即联系您的专属顾问",
    telegramConsult: "Telegram咨询客服 免费试用",
    socialTitle: "社交标题",
    personalizedService: "深度个性化服务",
    terminologyManagement: "术语管理",
  },
  // UserInstance页面
  userInstance: {
    userFeedback: "用户使用反馈",
    title: "用户实例",
    instanceList: "实例列表",
    createInstance: "创建实例",
    instanceName: "实例名称",
    instanceType: "实例类型",
    status: "状态",
    createTime: "创建时间",
    operation: "操作",
    start: "启动",
    stop: "停止",
    delete: "删除",
    edit: "编辑",
    running: "运行中",
    stopped: "已停止",
    pending: "待启动",
    contactAdvisor: "立即联系您的专属顾问",
    telegramConsult: "Telegram咨询客服 免费试用",
    description:
      "系统支持多语种界面与实时翻译，即时转换客对话，让您不用担心语言隔阂。",
    contactConsultant: "立即联系您的专属顾问",
    bannerTitle: "用户使用案例",
    bannerDesc1: "为您提供其他的用户使用截图参考！",
    bannerDesc2: "一方面突出我们的产品优势同时也为您的使用提供参考。采用CHAT GPT 5.0实现毫秒级别的高效翻译，满足客户的感官上的需求。",
    users: [
      {
        name: "孙思达",
        company: "湖南钉图互动公司",
        testimonial: "这款TranGPT人工智能AI高效简洁的翻译功能实在是太棒了！它将我的聊天记录翻译成了99+种语言，而且实时聊天翻译，像母语人士一样与客户进行交流。"
      },
      {
        name: "周小艺",
        company: "上海晶鼎轩公司",
        testimonial: "它可以帮助用户更快地完成任务，并节省时间和精力。它的翻译速度非常快，而且很准确。用户可以使用它快速完成日常任务，如文件翻译、邮件回复等。该工具非常适合需要快速翻译或处理大量数据的任务，如教育、医疗、金融等领域。"
      },
      {
        name: "赵玉凤",
        company: "湖北金湖港式公司",
        testimonial: "这款软件还支持 INSTAGRAM、 FACEBOOK、 LINE TELEGRAM等全球主流即时通讯软件聊天自动实时翻译，让我能够随时随地与好友进行交流。还可以帮助我快速翻译电子邮件，让我无需花费大量时间进行邮件回复，翻译非常准确！"
      },
      {
        name: "吴萱萱",
        company: "江苏飞索公司",
        testimonial: "我对它的翻译效果非常满意，准确率高。它的功能非常实用，让我能够轻松地将一种语言翻译成另一种语言。"
      },
      {
        name: "郑婷雅",
        company: "天津诺维信公司",
        testimonial: "使用TranGPT人工智能AI高效简洁的翻译功能非常方便，无需编写任何代码，也不需要训练数据。使用它翻译的结果质量也很高，无论是英语还是其他语言。我很喜欢这种工具，因为它可以帮助我快速了解一种语言中的意思。"
      },
      {
        name: "冯思钗",
        company: "广东思锐公司",
        testimonial: "给了我很大的帮助和惊喜。也能够快速准确地翻译大量文本，这非常适合我这样的写作者使用。它还可以帮我快速翻译和校对大量文本，这对于撰写文章也非常有用。"
      }
    ]
  },

  registerSuccess: {
    title: "注册成功！",
    message: "恭喜您成功注册TranGPT账户，现在您可以开始体验我们的服务了。",
    welcomeMessage: "欢迎加入TranGPT！",
    goToLogin: "立即登录",
    goToHome: "返回首页",
    autoRedirect: "{seconds}秒后自动跳转到登录页面",
  },

  about: {
    aboutCompany: "关于 Mohist AI Limited",
    companyDescription:
      "Mohist AI Limited总部位于香港，是一家以人工智能（AI）、大数据、云计算和物联网（IoT）为核心的高科技企业，致力于为全球企业提供数字化转型解决方案。我们以'技术赋能商业未来'为使命，通过创新技术帮助客户提升效率、优化体验并开拓新增长路径。公司依托香港的全球网络，业务辐射亚洲乃至世界市场。",
    aboutTranGPT: "关于 TranGPT",
    trangptDescription:
      "TranGPT，这是一款基于人工智能的多语言翻译和文本转语音 (TTS) 软件即服务 (SaaS) 平台。TranGPT 专为跨境电商、国际金融和全球业务打造，通过在安全、可扩展的环境中提供企业级翻译准确性和类人语音合成，重新定义了实时沟通。TranGPT 旨在为跨境电商卖家、金融专业人士和国际企业提供快速、准确且适应不同文化的沟通解决方案",
    contactUs: "联系我们",
    contactDescription: "了解更多信息和社区更新，请加入 TranGPT 官方频道",
    telegramEnglish: "Telegram（English）",
    telegramChinese: "Telegram（中文）",
    telegramSupport: "Telegram（客服支持）",
    whatsappSupport: "WhatsApp支持",
    contactAdvisor: "立即联系您的专属顾问",
    telegramConsult: "Telegram咨询客服 免费试用",
  },
  terms: {
    pageTitle: "服务协议",
    updatedAt: "最近更新日期：2026年9月8日",
    intro:
      "欢迎使用 TranGPT（以下简称“本平台”“我们”）。本服务协议（以下简称“本协议”）由您（以下简称“用户”“您”）与 Mohist AI Limited 之间订立，适用于您对 TranGPT 网站、客户端及相关服务（以下统称“本服务”）的注册、登录及使用行为。在使用本服务前，请您仔细阅读并充分理解本协议全部内容，尤其是免除或限制责任的条款。一旦您完成注册、登录或以任何方式使用本服务，即视为您已阅读、理解并同意接受本协议的全部内容。",
    sections: [
      {
        title: "一、协议的接受与适用范围",
        content:
          "1.1 本协议是您与我们之间关于使用 TranGPT 服务所订立的协议，适用于本服务的全部功能与页面。\n1.2 我们可能会根据法律法规变化及业务运营需要不时修订本协议，修订后的协议将在本页面公布，并自公布之日起生效，恕不再另行个别通知。若您在协议内容更新后继续使用本服务，即视为您已接受修订后的协议。\n1.3 如您不同意本协议的任何内容，请立即停止使用本服务并注销账号。",
      },
      {
        title: "二、服务说明",
        content:
          "2.1 TranGPT 是一款基于人工智能技术提供多语言文本翻译、文档翻译、语音合成（TTS）及相关 API 接入能力的软件即服务（SaaS）平台。\n2.2 我们将尽合理商业努力保障服务的稳定性与准确性，但由于人工智能翻译技术本身存在局限性，翻译结果可能存在误差，具体内容准确性以实际输出为准，我们不对翻译结果的绝对准确性作出保证。\n2.3 我们保留根据产品规划、技术升级或经营需要，对本服务的功能、内容进行调整、新增或下线的权利。",
      },
      {
        title: "三、账号注册与安全",
        content:
          "3.1 您在注册时应提供真实、准确、完整的邮箱等信息，并在信息发生变更时及时更新。\n3.2 您应妥善保管账号及密码，因您保管不善导致账号被他人使用或信息泄露的，由您自行承担由此产生的责任及损失。\n3.3 如发现任何未经授权使用您账号的情况，请立即通知我们，我们将在合理时间内采取相应措施。\n3.4 每个账号仅限本人使用，未经我们书面同意，不得转让、出租或以其他方式许可他人使用。",
      },
      {
        title: "四、用户行为规范",
        content:
          "4.1 您承诺不会利用本服务从事任何违反中华人民共和国法律法规、您所在地法律法规或国际公约的行为，包括但不限于：上传、翻译或传播违法、侵权、淫秽、暴力、诈骗性内容。\n4.2 您不得利用本服务实施网络攻击、恶意注册、批量爬取、干扰服务正常运行等行为。\n4.3 您应对通过本服务上传、翻译或生成的内容的合法性负责，我们有权对违反本协议或法律法规的内容进行删除、屏蔽，并有权视情节严重程度暂停或终止向您提供服务。",
      },
      {
        title: "五、知识产权",
        content:
          "5.1 本服务所涉及的软件、技术、页面设计、商标、Logo 等知识产权归 Mohist AI Limited 或相关权利人所有，受法律保护。\n5.2 您上传的原始文本、文档等内容的知识产权归您或原权利人所有；您使用本服务生成的翻译结果，在您遵守本协议及合法使用的前提下，可用于您自身的合法用途。\n5.3 未经我们书面许可，任何单位或个人不得复制、修改、传播或将本服务用于商业性反向工程、反编译等行为。",
      },
      {
        title: "六、费用与订阅",
        content:
          "6.1 本服务可能包含免费额度及付费订阅套餐，具体价格、计费方式及权益以订阅页面或购买页面公布的信息为准。\n6.2 除法律法规另有规定或我们另行承诺外，已支付的费用一般不予退还，具体退款政策以购买时页面说明或双方另行约定为准。\n6.3 我们可能根据市场情况调整价格及套餐内容，调整前将通过网站公告或其他合理方式告知。",
      },
      {
        title: "七、免责声明与责任限制",
        content:
          "7.1 本服务按“现状”提供，我们不对服务不中断、及时、安全、无错误作出保证。\n7.2 因不可抗力（包括但不限于自然灾害、政府行为、网络运营商故障、黑客攻击等）导致服务中断或数据损失的，我们不承担相应责任，但将尽力减少因此给您造成的损失。\n7.3 在法律允许的最大范围内，我们对因使用或无法使用本服务而产生的任何间接、附带、特殊或惩罚性损害不承担责任。",
      },
      {
        title: "八、服务的中止与终止",
        content:
          "8.1 如您违反本协议约定，我们有权视情节轻重对您的账号采取警告、限制功能、暂停服务直至终止服务并注销账号等措施。\n8.2 您可以随时通过账号中心或联系客服申请注销账号，账号注销后，除法律法规另有规定外，我们将按照隐私政策处理您的相关数据。",
      },
      {
        title: "九、协议的修改",
        content:
          "我们保留在必要时修改本协议的权利。修改后的协议将在本页面公布并载明更新日期。若您在协议更新后继续使用本服务，视为您已同意更新后的协议内容。",
      },
      {
        title: "十、适用法律与争议解决",
        content:
          "10.1 本协议的订立、效力、解释及争议解决均适用中华人民共和国香港特别行政区法律（不含冲突法规范）。\n10.2 若您与我们之间就本协议内容或其执行发生任何争议，双方应首先友好协商解决；协商不成的，任何一方均可将争议提交有管辖权的法院解决。",
      },
      {
        title: "十一、联系方式",
        content:
          "如您对本协议内容有任何疑问、意见或建议，可通过邮箱 contact@trangpt.ai 与我们联系，我们将尽快为您处理。",
      },
    ],
  },
  privacy: {
    pageTitle: "隐私政策",
    updatedAt: "最近更新日期：2026年9月8日",
    intro:
      "Mohist AI Limited（以下简称“我们”）非常重视用户的隐私和个人信息保护。本隐私政策旨在向您说明我们在您注册、登录及使用 TranGPT 服务（以下统称“本服务”）过程中，如何收集、使用、存储、共享及保护您的个人信息，以及您所享有的相关权利。请您在使用本服务前，仔细阅读并充分理解本隐私政策的全部内容。",
    sections: [
      {
        title: "一、我们收集的信息",
        content:
          "1.1 账号信息：当您注册或登录时，我们会收集您的邮箱地址、密码（加密存储）、验证码验证记录等信息。\n1.2 业务信息：根据您在注册或使用过程中主动填写的信息，我们可能收集团队规模、联系方式（如 Telegram、WhatsApp、微信）、邀请码等信息，用于提供针对性的产品与服务支持。\n1.3 使用数据：包括您通过本服务上传或提交的待翻译文本、文档及生成的翻译、语音结果，用于向您提供翻译与语音合成服务。\n1.4 设备与日志信息：包括访问时间、IP 地址、浏览器类型、操作系统、访问路径等日志信息，用于保障服务安全、排查故障及改进产品体验。",
      },
      {
        title: "二、我们如何使用信息",
        content:
          "2.1 用于创建和管理您的账号，验证您的身份，向您提供登录、找回密码等基础功能。\n2.2 用于提供、维护、优化本服务的翻译、语音合成及 API 等核心功能。\n2.3 用于向您发送与服务相关的通知，例如验证码、账户安全提醒、服务变更通知等。\n2.4 在获得您同意或法律允许的情况下，用于产品改进、数据统计分析及市场推广。\n2.5 我们不会将您的信息用于本政策未说明的其他目的，如需变更使用目的，我们将重新征得您的同意。",
      },
      {
        title: "三、信息的共享、转让与披露",
        content:
          "3.1 我们不会将您的个人信息出售给任何第三方。\n3.2 我们可能会与为我们提供云存储、支付处理、短信/邮件发送、客服支持等服务的合作伙伴共享必要信息，这些合作伙伴仅可在为我们提供服务所必需的范围内处理您的信息，并需遵守相应的保密义务。\n3.3 在法律法规要求、司法机关或行政机关依法要求，或为保护我们、用户及公众的合法权益免受损害的情况下，我们可能会依法披露您的信息。\n3.4 如涉及合并、收购、资产转让等交易，您的信息可能作为交易的一部分被转移，我们将要求新的持有方继续遵守本隐私政策。",
      },
      {
        title: "四、数据存储与安全",
        content:
          "4.1 我们采取符合行业标准的安全技术措施（包括但不限于密码加密存储、传输加密、访问权限控制）来保护您的个人信息，防止信息被未经授权访问、披露、篡改或损毁。\n4.2 我们会在实现本政策所述目的所必需的期限内保留您的个人信息，超出保留期限后，我们将对信息进行删除或匿名化处理，法律法规另有规定的除外。\n4.3 尽管我们已采取上述措施，但请您理解，由于技术的限制及可能存在的各种恶意手段，互联网环境并非百分之百安全，我们将尽最大努力保障您信息的安全。",
      },
      {
        title: "五、Cookie 及同类技术的使用",
        content:
          "为使您获得更好的访问体验，我们可能会使用 Cookie 及同类技术收集您的语言偏好、登录状态等信息，用于记住您的登录设置、分析网站访问情况。您可以通过浏览器设置管理或清除 Cookie，但这可能会影响部分功能的正常使用。",
      },
      {
        title: "六、您的权利",
        content:
          "6.1 您有权访问、更正您在本服务中留存的个人信息。\n6.2 您有权申请删除您的个人信息或注销账号，但法律法规另有规定的除外。\n6.3 您可以通过账号中心管理您的账号信息，或通过本政策载明的联系方式与我们联系以行使上述权利，我们将在合理期限内响应您的请求。",
      },
      {
        title: "七、未成年人保护",
        content:
          "本服务主要面向成年用户及企业客户。若您为未成年人，请在监护人的陪同和指导下阅读本政策并使用本服务。如我们发现在未获得监护人同意的情况下收集了未成年人的个人信息，将尽快采取措施删除相关信息。",
      },
      {
        title: "八、隐私政策的变更",
        content:
          "我们可能会适时修订本隐私政策的内容。任何对本政策所做的变更，我们将通过在本页面公布更新版本的方式告知您。若您在政策更新后继续使用本服务，即视为您同意更新后的隐私政策。",
      },
      {
        title: "九、联系我们",
        content:
          "如您对本隐私政策或您的个人信息处理事宜有任何疑问、意见或投诉，可通过邮箱 contact@trangpt.ai 与我们联系，我们将尽快审核并在合理期限内予以回复。",
      },
    ],
  },
};
